// Stepper maths for the Automations knobs at ≤880px (mobile overhaul Phase D
// §14.1 A): the − / + buttons replace the desktop number input, so the clamp
// the input's min/max used to do has to live somewhere testable. The server
// re-validates every knob (worker/routes/automations.ts KNOB_RULES) — these
// helpers only keep the UI from ever sending an out-of-range value.

export interface KnobRange {
  min: number;
  max: number;
  /** Whole units unless a knob ever needs coarser steps. */
  step?: number;
}

/** Whole number inside [min, max]; anything unusable falls back to min. */
export function clampKnob(value: number, range: KnobRange): number {
  if (!Number.isFinite(value)) return range.min;
  return Math.min(range.max, Math.max(range.min, Math.round(value)));
}

/** One tap of − (direction -1) or + (direction 1), clamped to the range. */
export function stepKnob(value: number, direction: -1 | 1, range: KnobRange): number {
  const step = range.step && range.step > 0 ? range.step : 1;
  return clampKnob(clampKnob(value, range) + direction * step, range);
}

/** The stepper button is dead at its end of the range — disabled, not silent. */
export function knobStepDisabled(value: number, direction: -1 | 1, range: KnobRange): boolean {
  const current = clampKnob(value, range);
  return direction === -1 ? current <= range.min : current >= range.max;
}

/** "days · 1–30" — the small line under the knob's label (mockup §14.1 A). */
export function knobRangeLabel(unit: string | null | undefined, range: KnobRange): string {
  const span = `${range.min}–${range.max}`;
  return unit ? `${unit} · ${span}` : span;
}
